import { configureStore, EnhancedStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import logger from 'redux-logger'

import { emptySplitApi } from 'emptySplitApi'

import { reducer } from './reducer'

const createStore = (): EnhancedStore => {
  const middleware = (getDefaultMiddleware: any) => {
    const middleware = getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(emptySplitApi.middleware)

    if (
      process.env.NODE_ENV !== 'production' &&
      !window.localStorage.getItem('fairhq-disable-redux-logger')
    ) {
      middleware.concat(logger)
    }

    return middleware
  }

  return configureStore({
    reducer,
    middleware,
  })
}

export const store = createStore()

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
